import React from "react";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <section className="home" id="home">
      <div className="home-inner">
        <div>
          <div className="hero-badge">Available for opportunities</div>
          <h1 className="home__heading">
            Ravindra<br />
            <span>Birla</span>
          </h1>
          <h2 className="home__text">
            <Typewriter
              options={{
                autoStart: true,
                loop: true,
                delay: 40,
                strings: [
                  "Full-Stack Developer",
                  "Angular Specialist",
                  "PostgreSQL Engineer",
                  "MERN Stack Builder",
                ],
              }}
            />
          </h2>
          <p className="home__desc">
            I build robust web applications — from Angular frontends to PostgreSQL
            backends. Currently working on government-scale disaster management systems.
          </p>
          <div className="hero-actions">
            <Link to="/projects" className="btn-primary">View Projects ↓</Link>
            <Link to="/contact" className="btn-ghost">Get in Touch</Link>
          </div>
          <div className="hero-stats">
            <div>
              <div className="hero-stat-num">3+</div>
              <div className="hero-stat-label">Years experience</div>
            </div>
            <div>
              <div className="hero-stat-num">10+</div>
              <div className="hero-stat-label">Projects built</div>
            </div>
            <div>
              <div className="hero-stat-num">MERN</div>
              <div className="hero-stat-label">+ Angular stack</div>
            </div>
          </div>
        </div>

        <div className="hero-card">
          <div className="code-block">
            <div className="code-bar">
              <div className="code-dot cd1" />
              <div className="code-dot cd2" />
              <div className="code-dot cd3" />
            </div>
            <pre>
{`\x1b[2m// Current role\x1b[0m
`}
              <span className="cm">{"// Current role"}</span>{"\n"}
              <span className="kw">const</span>{" "}
              <span className="var-name">developer</span> {"= {"}{"\n"}
              {"  "}<span className="fn">name</span>{": "}
              <span className="str">"Ravindra Birla"</span>,{"\n"}
              {"  "}<span className="fn">focus</span>{": "}
              <span className="str">"Angular + PostgreSQL"</span>,{"\n"}
              {"  "}<span className="fn">project</span>{": "}
              <span className="str">"dm-ui (Gov.)"</span>,{"\n"}
              {"  "}<span className="fn">stack</span>{": ["}{"\n"}
              {"    "}<span className="str">"Angular 21"</span>,{" "}
              <span className="str">"TypeScript"</span>,{"\n"}
              {"    "}<span className="str">"PostgreSQL"</span>,{" "}
              <span className="str">"Node.js"</span>,{"\n"}
              {"  ],"}{"\n"}
              {"  "}<span className="fn">status</span>{": "}
              <span className="str">"open to work"</span>{" "}
              <span className="num">✓</span>{"\n"}
              {"};"}
            </pre>
          </div>
          <div className="stack-tags">
            {["Angular", "TypeScript", "PostgreSQL", "Node.js", "React", "MongoDB"].map(t => (
              <span key={t} className="tag">{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
